import React from 'react';

const Card = ({ 
  children, 
  title = '', 
  subtitle = '',
  actions = null,
  hoverable = false,
  padding = '20px',
  marginBottom = '0',
  style = {},
  onClick = null
}) => {
  const cardStyle = {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    padding: padding,
    marginBottom: marginBottom,
    transition: 'all 0.3s ease',
    cursor: onClick ? 'pointer' : 'default',
    ...style
  };

  const headerStyle = {
    marginBottom: title || subtitle ? '16px' : '0'
  };

  const titleStyle = {
    fontSize: '18px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: subtitle ? '4px' : '0'
  };

  const subtitleStyle = {
    fontSize: '14px',
    color: 'var(--text-secondary)'
  };

  const actionsStyle = {
    marginTop: '16px',
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end'
  };

  return (
    <div
      style={cardStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (hoverable || onClick) {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (hoverable || onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
    >
      {(title || subtitle) && (
        <div style={headerStyle}>
          {title && <h3 style={titleStyle}>{title}</h3>}
          {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
        </div>
      )}
      {children}
      {actions && <div style={actionsStyle}>{actions}</div>}
    </div>
  );
};

export default Card;